import { useState, useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
// Hooks
import handleNotification from 'utils/toast/handleNotification'
// Constants && Context
import WORDING from 'constants/wording'
import { MeContext } from '../../contexts/me'
// Components
import PrimaryButton from '../../components/primaryButton'
import AliasInput from './aliasInput'
import PageWrapper from '../../components/PageWrapper'
// Api
import { modifyAlias } from '../../api/cvu'

export default function Alias() {
  const methods = useForm({ mode: 'onChange' })
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { me } = useContext(MeContext)
  const [isAliasDisabled, setAliasDisabled] = useState(false)
  const { successToast, errorToast } = handleNotification()

  async function onConfirm() {
    setLoading(true)
    const cvu_alias = methods.getValues('xxlField')
    modifyAlias({ cvu_alias })
      .then((response) => {
        if (response.data) {
          successToast(WORDING.ALIAS_MODIFICADO)
        } else if (
          response.error &&
          response.error.code === 'RECENT_ALIAS_CHANGED'
        ) {
          errorToast('¡Ups! Podés cambiar tu alias nuevamente en 24 hs.')
        } else if (response.error && response.error.message) {
          errorToast('¡Uh! Algo salió mal. Intentá de nuevo más tarde.')
        }
      })
      .catch(() => {
        errorToast('¡Uh! Algo salió mal. Intentá de nuevo más tarde.')
      })
      .finally(() => {
        methods.setValue('xxlField', '')
        setLoading(false)
        navigate('/cvu')
      })
  }

  return (
    <PageWrapper noTabBar title='Modificar alias'>
      <section className='flex flex-col text-center text-black items-center mx-auto justify-center sm:max-w-564 mt-8'>
        <FormProvider {...methods}>
          <div className='max-w-[974px] my-0 mx-auto '>
            <div className='bg-color-gray-100 items-center'>
              {me ? (
                <AliasInput
                  setDisabled={setAliasDisabled}
                  inputText={me?.bank?.internal_account[0].cvu_alias}
                />
              ) : (
                <Skeleton height={200} />
              )}

              {/* Button */}
              <div className='xs:absolute xs:bottom-20 xs:px-3 xs:right-0 xs:left-0 sm:relative  sm:mt-40 sm:w-40 md:w-40 sm:ml-auto'>
                <PrimaryButton
                  buttonText='Modificar'
                  outlined={false}
                  primaryButtonFunction={onConfirm}
                  isLoading={loading}
                  isDisabled={isAliasDisabled}
                />
              </div>
            </div>
          </div>
        </FormProvider>
      </section>
    </PageWrapper>
  )
}
